import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-199fc0d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = { id: "about2" }
const _hoisted_3 = { class: "jieti1" }
const _hoisted_4 = { class: "jieti2" }
const _hoisted_5 = { class: "jieti3" }
const _hoisted_6 = { class: "jieti3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dibu" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dibu1" }, " 纳入106例AD患者，所有患者符合康克非修订的AD诊断标准，依据双盲法将患者随机分为对照组和联合组各53例。患者均进行酮替芬片口服治疗，对照组患者单独使用丁酸氢化可的松软膏，联合组患者使用莫匹罗星软膏+丁酸氢化可的松软膏进行治疗，每日2次，连续用药2周，比较两组患者临床治疗效果 ")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dibutwo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dibutwo1" }, " 邬美俊. 临床医药文献电子杂志,2018,5(28):82-83. ")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h20" }, null, -1))
const _hoisted_11 = { class: "bottomBox" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_toNav = _resolveComponent("toNav")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_image, {
        width: "2.3733rem",
        height: ".52rem",
        src: require('../assets/newlogo.png')
      }, null, 8, ["src"])
    ]),
    _createVNode(_component_van_popup, {
      show: true,
      style: {"top":"50%"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_van_image, {
              width: "8.4667rem",
              height: "1.3867rem",
              src: require('../assets/bijiao1.png')
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_van_image, {
              width: "8.0133rem",
              height: "3.5067rem",
              src: require('../assets/bijiao2.png')
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_van_image, {
              width: "8.3333rem",
              height: "1.3867rem",
              src: require('../assets/bijiao3.png')
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_van_image, {
              width: "8.0133rem",
              height: "3.6933rem",
              src: require('../assets/bijiao4.png')
            }, null, 8, ["src"])
          ]),
          _hoisted_7,
          _hoisted_8,
          _hoisted_9
        ]),
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_van_image, {
            onClick: $options.biaoming,
            width: "6.1067rem",
            height: "1.1467rem",
            src: require('../assets/chakanliaoxiao.png')
          }, null, 8, ["onClick", "src"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_toNav, { menu: 3 })
  ], 64))
}